import { IFilesState } from '@/@types'

const state: IFilesState = {
  contentFiles: null,
  filesDownloadLinks: {},
  filesRendered: {},
}

export default state
